import {useState, useEffect} from 'react';
import {
    Box,
    Typography,
    Button,
    Card,
    TextField,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { VerticalSpace } from '../components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {toast} from 'react-toastify';
import axios from 'axios';

const Login = ({web3Auth, provider, setProvider}) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const login = async () => {
        if (!web3Auth) {
            console.log("web3auth not initialized yet");
            return;
        }
        setIsLoading(true);
        const web3authProvider = await web3Auth.connect();
        setProvider(web3authProvider);

        const testDoc = searchParams.get('testDoc');
        const {email, name} = await web3Auth.getUserInfo();
        const userLog = await web3Auth.getUserInfo();

        // console.log("USER", userLog)

        const {data} = await axios.post("https://dapp-backend.triadkube.com/auth/create-profile", {email, name, role: 'PARENT'})
        setIsLoading(false);
        localStorage.setItem('brainsprays-accountId', data.result.user._id)
        
        if(data.result.newUser)
            navigate(`/create-profile?email=${email}&testDoc=${testDoc}`)
        else
            navigate(`/dashboard?id=${data.result.user._id}&testDoc=${testDoc}`)
    };
    
    useEffect(() => {
        const testDoc = searchParams.get('testDoc')
        const accountId = localStorage.getItem('brainsprays-accountId')

        if(accountId) {
            navigate(`/dashboard?testDoc=${testDoc}`)
        }
     }, [])

    return (
        <Box>
            <Card
                sx={{
                    padding: '50px'
                }}
            >
                <Typography>Login to take the assessment and create a digital wallet for you to add a NFT token</Typography>
                <VerticalSpace count={2} />
                <Box>
                    <LoadingButton loading={isLoading} loadingIndicator="Loading..." variant='contained' onClick={login} >Login</LoadingButton>
                </Box>
            </Card>
        </Box>
    )
}

export default Login;